import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

class Favorite extends React.Component {
  state = {
    favorite: get(this.props, 'tool.favorite', false)
  };

  handleFavorite = () => {
    const { tool, toggleFavorite } = this.props;
    // update state to show animation
    this.setState({ favorite: !this.state.favorite });
    // call handler function to update database and store
    toggleFavorite(tool);
  };

  render() {
    return (
      <div
        className={
          'myapps-card-favorite-icon' + (this.state.favorite ? ' faved' : '')
        }
        role="button"
        tabIndex={0}
        onKeyDown={e => e.keyCode === 13 && this.handleFavorite()}
        onClick={this.handleFavorite}
      />
    );
  }
}

Favorite.propTypes = {
  tool: PropTypes.object,
  toggleFavorite: PropTypes.func
};

export default Favorite;
